import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { BaseComponent } from './base.component';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export abstract class BaseTabsComponent extends BaseComponent implements OnInit {

  public readonly queryParamName: string = 'tab';
  public readonly activeTabSub: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  protected constructor(protected router: Router, protected route: ActivatedRoute) {
    super();
    const tab = +this.route.snapshot.queryParams[this.queryParamName];
    this.activeTabSub.next(!isNaN(tab) ? tab : 0);
  }

  public ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        const tab = +this.route.snapshot.queryParams[this.queryParamName];
        this.activeTabSub.next(!isNaN(tab) ? tab : 0);
      });
  }

  public setQueryParam(tab: number): void {
    this.activeTabSub.next(tab);
    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: { [this.queryParamName]: tab ? tab : null },
        queryParamsHandling: 'merge' // remove to replace all query params by provided
      });
  }
}
